export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/freelance_impact_perseus/freelance-economy-2020.19b5fd7.pdf";